<template>
  <!-- <span
    class="relative rounded-full flex-shrink-0 min-h-6 flex items-center"
    :style="{
      backgroundColor: statuses[status].backgroundColor,
      color: statuses[status].color,
      fontSize: '0.875rem',
      padding: '0.25rem 0.5rem'
    }"
  >
    {{ statuses[status].label }}
  </span> -->
  <span
    :data-id="id"
    class="relative flex items-center rounded-full flex-shrink-0"
    :class="{
      'h-7': !dense,
      'h-6': dense
    }"
    :title="currentChip.label"
    :style="{
      backgroundColor: currentChip.backgroundColor,
      padding: '0rem 0.5rem'
    }"
  >
    <BlTextBody3
      :data-id="id"
      :text="currentChip.label"
      class="truncate"
      :class="{
        'text-sm': !dense,
        'text-xs': dense
      }"
      :style="{ color: currentChip.color }"
    />
  </span>
</template>

<script>
import BlTextBody3 from "../../BlTextBody3.vue";

export default {
  name: "StatusChip",
  components: { BlTextBody3 },
  props: {
    id: {
      type: String,
      default: "bl-chip"
    },
    status: {
      type: String,
      default: "pending"
    },
    color: {
      type: String,
      required: false,
      default: "cornflower" // cornflower
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const DARK_PURPLE_1 = "#564389";
    const LIGHT_PURPLE_1 = "#E7E0EC";
    // const GREY = "#363636";
    // const GREY_2 = "#E4E4E4";
    //
    const SLATE_8 = "#475467";
    const SLATE_3 = "#F2F4F7";
    // const ROSE_7 = "#F63D68";
    // const ROSE_2 = "#FFF1F3";
    // const ORANGE_7 = "#FB6514";
    // const ORANGE_2 = "#FFF6ED";
    const LIME_7 = "#789719";
    const LIME_2 = "#F2F8CF";
    const CORNFLOWER_8 = "#0172A3";
    const CORNFLOWER_2 = "#E0F4FE";
    const TULIP_8 = "#A66402";
    const TULIP_2 = "#FFFBC1";
    // const TULIP_7 = "#D18D00";
    // const TULIP_1 = "#FFFDE7";
    const GRASS_8 = "#457C0F";
    // const GRASS_3 = "#D3F99D";
    const GRASS_2 = "#E9FCCB";
    const TOMATO_7 = "#DD3F30";
    const TOMATO_2 = "#FEE4E2";
    return {
      statuses: {
        // target status
        pending: {
          label: "Pending",
          color: SLATE_8,
          backgroundColor: SLATE_3
        },
        in_progress: {
          label: "In acquisition",
          color: TULIP_8,
          backgroundColor: TULIP_2
        },
        paused: {
          label: "Paused",
          color: DARK_PURPLE_1,
          backgroundColor: LIGHT_PURPLE_1
        },
        mastered: {
          label: "Mastered",
          color: GRASS_8,
          backgroundColor: GRASS_2
        },
        discontinued: {
          label: "Discontinued",
          color: TOMATO_7,
          backgroundColor: TOMATO_2
        }
      },
      colors: {
        purple: { color: DARK_PURPLE_1, backgroundColor: LIGHT_PURPLE_1 },
        slate: { color: SLATE_8, backgroundColor: SLATE_3 },
        lime: { color: LIME_7, backgroundColor: LIME_2 },
        cornflower: { color: CORNFLOWER_8, backgroundColor: CORNFLOWER_2 },
        tulip: { color: TULIP_8, backgroundColor: TULIP_2 }
      }
    };
  },
  computed: {
    currentChip() {
      const found = this.statuses[this.status];
      if (found) return found;
      const used = this.colors[this.color] || this.colors["cornflower"];
      return {
        label: this.status,
        color: used.color,
        backgroundColor: used.backgroundColor
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/StatusChip.vue